import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import CityPicker from "src/components/CityPicker";
import { getAreas } from "src/services/request";
import { useSelector } from "react-redux";
import AreaStatsDialog from "src/pages/stats/components/AreaStatsDialog";
import RangliTrend from "./components/RangliTrend";
import AreaMersStatDialog from "./components/AreaMersStatDialog";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import AreaMersDialog from "./components/AreaMersDialog";

const sortList = [
  { label: "本年业绩", value: "year" },
  { label: "上月业绩", value: "lastMonth" },
  { label: "本月业绩", value: "month" },
  { label: "上周业绩", value: "lastWeek" },
  { label: "本周业绩", value: "week" },
  { label: "昨日业绩", value: "yesterday" },
  { label: "今日业绩", value: "today" },
];

const TABLE_HEAD = [
  // { id: "mid", label: "ID", alignRight: false },
  { id: "name", label: "城市", alignRight: false },
  { id: "total", label: "业绩", alignRight: false },
  { id: "count", label: "消费笔数", alignRight: false },
  { id: "mersAdded", label: "新增商户", alignRight: false },
  { id: "mersTotal", label: "累计商户", alignRight: false },
  // { id: "yearly", label: "年业绩（元）", alignRight: false },
  // { id: "monthly", label: "月业绩（元）", alignRight: false },
  // { id: "yesterday", label: "昨日业绩（元）", alignRight: false },
  // { id: "today", label: "今日业绩（元）", alignRight: false },
  // { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "区业绩", icon: iconEdit2 },
  { title: "月趋势", icon: iconEdit2 },
  { title: "日趋势", icon: iconEdit2 },
];

export default function StatsArea() {
  const areaMap = useSelector((state) => state.globalData.areaMap);
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [targetCity, setTargetCity] = useState(null);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [dailyTotal, setDailyTotal] = useState({});
  const [trendInfo, setTrendInfo] = useState({});

  const [cityMap, setCityMap] = useState({});
  const [action, setAction] = useState("");

  const [areaItems, setAreaItems] = useState([]);

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    search: "",
    provinceId: null,
    cityId: null,
    districtId: null,
    createdAt: null,
    sort: "today",
  });

  useEffect(() => {
    getAreas();
  }, []);

  // console.log('areaMap', areaMap)

  useEffect(() => {
    if (!areaMap) return;
    getItems();
  }, [areaMap, filter]);

  async function getItems() {
    const { data } = await asyncRequest({
      path: "/stats/area",
      data: filter,
    });

    const arr = [];

    for (let k in data) {
      const item = {
        // cityId: k,
        // cityName: areaMap[k],
        districtId: k,
        districtName: areaMap[k],
        total: data[k].reduce((prev, next) => prev + next.rangli, 0),
        count: data[k].reduce((prev, next) => prev + next.count, 0),
        mersAdded: data[k].reduce((prev, next) => prev + next.mersAdded, 0),
        mersTotal: data[k][data[k].length - 1].mersTotal,
      };

      arr.push(item);
    }

    arr.sort((a1, a2) => a2.total - a1.total);

    setItems(arr);
    setCityMap(data);
  }

  async function getDailyTotal() {
    const { data } = await asyncRequest({
      path: "/stats/daily",
      data: filter,
    });

    setDailyTotal(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = async (type, row) => {
    if (type === "区业绩") {
      // navigate(`/merchant/edit/${row.mid}`, { state: row });
      // setTargetCity(row);
      setTargetCity(row);
      setAreaItems(cityMap[row.cityId]);
      setAction("area");
    } else if (type === "月趋势") {
      getCityTrends({
        level: "district",
        targetId: row.cityId,
        time: "monthly",
      });
    } else if (type === "日趋势") {
      getCityTrends({
        level: "district",
        targetId: row.cityId,
        time: "daily",
      });
    }
  };

  async function getCityTrends(formData) {
    const { data } = await asyncRequest({
      path: "/stats/trend",
      data: formData,
    });

    setTrendInfo({
      title: `${areaMap[formData.targetId]}月度业绩趋势`,
      labels: data.map((d) => d.date),
      data: [
        {
          name: "消费额",
          type: "area",
          data: data.map((d) => d.list.reduce((prev, next) => prev + next.total, 0)),
        },
        {
          name: "让利额",
          type: "line",
          data: data.map((d) => d.list.reduce((prev, next) => prev + next.rangli, 0)),
        },
      ],
    });
    setAction("trend");
  }

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="区域业绩">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              区域业绩
            </Typography>
          </Stack>

          <Card>
            <ListToolbar
              filterName={filter.search}
              onFilterName={handleFilterByName}
              onRefresh={() => {
                getItems();
                getDailyTotal();
              }}
            >
              <MyDateRangePicker
                value={filter.createdAt}
                onChange={(val) => {
                  setFilter({
                    ...filter,
                    createdAt: val,
                  });
                }}
              />

              <FormControl size="small">
                <InputLabel id="demo-simple-select-label">检索方式</InputLabel>
                <Select
                  // labelId="demo-simple-select-label"
                  // id="demo-simple-select"
                  label="检索方式"
                  value={filter.sort}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      sort: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {sortList.map((item, idx) => (
                    <MenuItem key={idx} value={item.value} name={item}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* <FormControl size="small">
                  <InputLabel id="version">查询方式</InputLabel>
                  <Select
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    label="查询方式"
                    value={filter.version}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        version: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[null, 1, 2].map((version, idx) => (
                      <MenuItem key={idx} value={version} name={version}>
                        {idx == 0 ? "全部" : ["全部", "1.0", "2.0"][version]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              <FormItem title="区域">
                <CityPicker
                  code={filter.provinceId}
                  onSelect={(val) => {
                    console.log(val);
                    setFilter({
                      ...filter,
                      districtId: val.district.id,
                    });
                  }}
                />
              </FormItem> */}
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <ListHead headLabel={TABLE_HEAD} />
                  <TableBody>
                    {items.map((row) => {
                      const { districtId, cityName, districtName, total, realname, yearly, monthly, yesterday, today, count, mersAdded, mersTotal } = row;
                      // const { monthly, daily, today } = merchant;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      // console.log(count, mersAdded, mersTotal)

                      return (
                        <TableRow hover key={districtId} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, mid)}
                            />
                          </TableCell> */}
                          {/* <TableCell align="left">{mid}</TableCell> */}
                          <TableCell align="left">{districtName}</TableCell>
                          <TableCell align="left">{total.toFixed(2)}</TableCell>
                          <TableCell align="left">{count}</TableCell>
                          <TableCell align="left">
                            <RouterLink
                              onClick={() => {
                                setTargetCity(row);
                                setAction("mersAdded");
                              }}
                            >
                              {mersAdded}
                            </RouterLink>
                          </TableCell>
                          <TableCell align="left">
                            <RouterLink
                              onClick={() => {
                                setTargetCity(row);
                                setAction("merRank");
                              }}
                            >
                              {mersTotal}
                            </RouterLink>
                          </TableCell>
                          <TableCell align="right">
                            <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {/* <TableRow>
                      <TableCell>
                        <Stack>
                          <Typography>年度业绩：{dailyTotal.yearly}元</Typography>
                          <Typography>本度业绩：{dailyTotal.monthly}元</Typography>
                          <Typography>昨日业绩：{dailyTotal.yesterday}元</Typography>
                          <Typography>今日业绩：{dailyTotal.today}元</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow> */}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        </Container>
      </Page>

      {action == "area" && <AreaStatsDialog open cityName={targetCity.cityName} rows={areaItems} areaMap={areaMap} onClose={() => setAction("")} />}
      {action == "trend" && <RangliTrend {...trendInfo} onClose={() => setAction("")} />}
      {action == "merRank" && <AreaMersStatDialog open districtId={targetCity.districtId} districtName={targetCity.districtName} onClose={() => setAction("")} />}
      {action == "mersAdded" && <AreaMersDialog createdAt={filter.createdAt} sort={filter.sort} open districtId={targetCity.districtId} districtName={targetCity.districtName} onClose={() => setAction("")} />}
    </>
  );
}
